module.exports = "/_next/static/images/77a2a2bda78b02541e51887459cf3ebe-roxinho-scene-card-with-phone-lg@3x.jpg.webp";